export enum Ethnicity {
  WHITE = 'White',
  BLACK = 'Black',
  BROWN = 'Brown',
  YELLOW = 'yellow',
  INDIGENOUS = 'Indigenous'
}
